import React, { useEffect, useState } from "react";
import { CampaignCard } from "../BookingOverview.styled";
import { useTranslation } from "react-i18next";
import { Collapse } from "../../../../../Components/Layout";
import { AddonItem } from "../utils/AddonItem";
import { BookingCollapse } from "../utils/BookingCollapse";
import { ADD_ON_PRICE } from "../../utils/constants";
import Actions from "../../../../../Actions";
import logger from "../../../../../utils/LoggerFrontend";

const createVoiceOption = (t) => ({
  title: t("Professional recording for Spotify"),
  description: t(
    "Your ad text will be recorded exclusively by Spotify employees. You will receive the clip within 3 working days."
  ),
  img: "/images/campaign-creation/spotify-voice.jpg",
  amount: 49
});

export const VoiceSection = ({ spotifyHumanVoiceStore, addOns, setAddOns = () => {} }) => {
  const { t } = useTranslation();
  const [collapse, setCollapse] = useState(true);
  const voiceOption = createVoiceOption(t);

  const [voiceCheck, setVoiceCheck] = useState(Boolean(spotifyHumanVoiceStore));

  const handleClick = (event) => {
    event.stopPropagation();
    setVoiceCheck(!voiceCheck);
  };

  useEffect(() => {
    logger.log("BookingOverview:draftSaved:updateVideoReview", "called...", spotifyHumanVoiceStore);

    if (spotifyHumanVoiceStore !== addOns.spotifyHumanVoice) {
      Actions.campaignCreateUpdateReviewData({
        spotifyHumanVoice: addOns.spotifyHumanVoice
      });
    }
  }, [spotifyHumanVoiceStore, addOns.spotifyHumanVoice]);

  useEffect(() => {
    setAddOns((prev) => ({
      ...prev,
      spotifyHumanVoice: voiceCheck ? ADD_ON_PRICE : null
    }));
  }, [voiceCheck, setAddOns]);

  return (
    <CampaignCard onClick={() => setCollapse(!collapse)}>
      <Collapse
        parent={
          <BookingCollapse
            collapse={collapse}
            title={t("Ad content")}
            cost={voiceCheck ? ADD_ON_PRICE : 0}
          />
        }
        show={collapse}
        marginBottom="-20px"
      >
        <AddonItem
          option={{ ...voiceOption, check: voiceCheck }}
          handleClick={(e) => handleClick(e)}
          t={t}
        />
      </Collapse>
    </CampaignCard>
  );
};
